@if (displayedNonBlockingError()) {
  <output class="non-blocking-error" aria-live="polite" aria-atomic="true">
    <div class="error-message-with-icon">
      <img src="assets/red-error-icon.svg" alt="" aria-hidden="true" />
      <p class="non-blocking-error-message">
        {{ nonBlockingErrorConfig().errorMessage }}
      </p>
    </div>
    @if (nonBlockingErrorConfig().isClosable) {
      <button
        type="button"
        class="non-blocking-error-close-button"
        aria-label="Dismiss error message"
        (click)="dismissNonBlockingError()"
      >
        &times;
      </button>
    }
  </output>
}
@if (blockingErrorConfig() !== null) {
  <div
    class="blocking-error-container"
    role="alert"
    aria-live="assertive"
    aria-labelledby="blocking-error-title"
    aria-describedby="blocking-error-message blocking-error-contact"
  >
    <div class="blocking-error-card">
      <div class="blocking-error-header">
        <h2 id="blocking-error-title" class="blocking-error-title">
          {{ blockingErrorConfig().errorHeader }}
        </h2>
      </div>
      <p id="blocking-error-message" class="blocking-error-message">
        {{ blockingErrorConfig().errorMessage }}
      </p>
      <p id="blocking-error-contact" class="blocking-error-contact">
        If this issue persists, contact us at
        <a
          [href]="contactMailtoHref()"
          target="_blank"
          rel="noopener noreferrer"
          >ewebdev&#64;vsp.com</a
        >.
      </p>
    </div>
  </div>
}
